import { useContext, useContextSelector } from 'use-context-selector';
import { ParametersContext } from './ParametersContext';
import { PartyRole } from './types';

const useParametersState = () => {
  const context = useContext(ParametersContext);

  if (context === undefined) {
    throw new Error('useParametersState must be used within ParametersProvider');
  }

  return context;
};

const useTransactionStatuses = () => {
  const context = useContextSelector(ParametersContext, state => state.transactionStatusesData ?? []);

  if (context === undefined) {
    throw new Error('useTransactionStatuses must be used within ParametersProvider');
  }

  return context;
};

const useTransactionTypes = () => {
  const context = useContextSelector(ParametersContext, state => state.transactionTypesData ?? []);

  if (context === undefined) {
    throw new Error('useTransactionTypes must be used within ParametersProvider');
  }

  return context;
};

const useOrderStatuses = () => {
  const context = useContextSelector(ParametersContext, state => state.orderStatusesData ?? []);

  if (context === undefined) {
    throw new Error('useParametersConsolidatedTransactionsTotalItems must be used within ParametersProvider');
  }

  return context;
};

const useCardHeaders = () => {
  const context = useContextSelector(ParametersContext, state => state.postLoginCardData?.cardHeaders);

  return context;
};

const useSelectedPartyIdentification = () => {
  const context = useContextSelector(ParametersContext, state => state.postLoginCardData?.selectedPartyIdentification);

  return context;
};

const usePartyRelationships = () => {
  const context = useContextSelector(ParametersContext, state => state.postLoginCardData?.partyRelationships);

  return context;
};

const usePartyRoles = () => {
  const context = useContextSelector(ParametersContext, state => state.postLoginCardData?.partyRoles);

  return context;
};

const useIsCardAdmin = () => {
  const context = useContextSelector(ParametersContext, state => state.postLoginCardData?.partyRoles);

  return context ? Boolean(context.find(role => role === PartyRole.CARD_ADMIN)) : false;
};

const useIsCardHolder = () => {
  const context = useContextSelector(ParametersContext, state => state.postLoginCardData?.partyRoles);

  return context ? context.length === 1 && context[0] === PartyRole.CARD_HOLDER : false;
};

export {
  useParametersState,
  useTransactionStatuses,
  useTransactionTypes,
  useOrderStatuses,
  useCardHeaders,
  useSelectedPartyIdentification,
  usePartyRelationships,
  usePartyRoles,
  useIsCardHolder,
  useIsCardAdmin,
};
